<template>
  <div class="step-main">
    <div class="step-main-head">
      <div class="step-main-head-content" data-track-text="H5返回历史文档" aria-label="H5返回历史文档" @click="()=>this.$router.push('/list')">
        <div><</div>
        <div>返回</div>
      </div>
    </div>
    <div v-if="(status!=='501'&&status!=='448')" class="step-main-content">
      <div class="step-main-content-title">{{ title }}</div>
      <div v-if="timeCost&&!overDate" class="step-main-content-time-cost">预计完成时间：{{ timeCost }}前</div>
      <div class="step-main-content-step">
        <div class="step-main-content-step-item">
          <div class="step-main-content-step-item-one">
            <img src="../../assets/img/ok.png" alt=""/>
          </div>
          <div class="step-main-content-step-item-two">
            <div>订单提交</div>
            <div style="height: 0px;margin-top: 20px;margin-bottom: -20px;">{{ orderDate || '-' }}</div>
          </div>
        </div>
        <div :class="orderDate?'step-main-content-step-space':'step-main-content-step-space-bank'"/>
        <div class="step-main-content-step-item">
          <div class="step-main-content-step-item-one">
            <img v-show="orderDate&&processDate" src="../../assets/img/ok.png" alt=""/>
            <img v-show="orderDate&&!processDate" src="../../assets/img/process.png" alt=""/>
            <img v-show="!orderDate" src="../../assets/img/no.png" alt=""/>
          </div>
          <div class="step-main-content-step-item-two">
            <div>等待客服沟通报价</div>
            <div style="height: 0px;margin-top: 20px;margin-bottom: -20px;">{{ processDate || '-' }}</div>
          </div>
        </div>
        <div :class="processDate?'step-main-content-step-space':'step-main-content-step-space-bank'"/>
        <div class="step-main-content-step-item">
          <div class="step-main-content-step-item-one">
            <img v-show="processDate&&payDate" src="../../assets/img/ok.png" alt=""/>
            <img v-show="processDate&&!payDate" src="../../assets/img/process.png" alt=""/>
            <img v-show="!processDate" src="../../assets/img/no.png" alt=""/>
          </div>
          <div class="step-main-content-step-item-two">
            <div>确认并支付订单</div>
            <div style="height: 0px;margin-top: 20px;margin-bottom: -20px;">{{ payDate || '-' }}</div>
          </div>
        </div>
        <div :class="payDate?'step-main-content-step-space':'step-main-content-step-space-bank'"/>
        <div class="step-main-content-step-item">
          <div class="step-main-content-step-item-one">
            <img v-show="payDate&&transDate" src="../../assets/img/ok.png" alt=""/>
            <img v-show="payDate&&!transDate" src="../../assets/img/process.png" alt=""/>
            <img v-show="!payDate" src="../../assets/img/no.png" alt=""/>
          </div>
          <div class="step-main-content-step-item-two">
            <div>翻译中</div>
            <div style="height: 0px;margin-top: 20px;margin-bottom: -20px;">{{ transDate || '-' }}</div>
          </div>
        </div>
        <div :class="transDate?'step-main-content-step-space':'step-main-content-step-space-bank'"/>
        <div class="step-main-content-step-item">
          <div class="step-main-content-step-item-one">
            <img v-show="transDate&&overDate" src="../../assets/img/ok.png" alt=""/>
            <img v-show="transDate&&!overDate" src="../../assets/img/process.png" alt=""/>
            <img v-show="!transDate" src="../../assets/img/no.png" alt=""/>
          </div>
          <div class="step-main-content-step-item-two">
            <div>翻译完成</div>
            <div style="height: 0px;margin-top: 20px;margin-bottom: -20px;">{{ overDate || '-' }}</div>
          </div>
        </div>
        <div class="step-main-content-foot">
          <div class="step-main-content-foot-title">
            <div></div>
            <div>客服热线</div>
          </div>
          <div class="step-main-content-foot-desc">
            支付问题请联系：010-80755328<br/>
            （工作日：周一至周五早9点至晚六点）或联系
            <span style="color: rgba(6, 63, 149, 1)" data-track-text="H5在线QQ咨询" aria-label="H5在线QQ咨询" @click="toQQ">在线QQ</span>
          </div>
          <div class="step-main-content-foot-desc" style="margin-top: 27px">
            翻译问题请联系：400-004-5131
          </div>
        </div>
      </div>
    </div>
    <div v-if="(status==='501'||status==='448')" class="step-main-content">
      <div v-if="status==='501'"
           style="    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 60px;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #E13F3F;flex-flow: row">
        <img
            src="../../assets/img/over.png" width="50" alt="" style="margin-right: 20px">文档已删除
      </div>
      <div v-if="status==='448'"
           style="    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 60px;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #E13F3F;flex-flow: row">
        <img
            src="../../assets/img/over.png" width="50" alt="" style="margin-right: 20px">任务已终止
      </div>
    </div>
    <div v-if="status==='431'||status==='432'||status==='396'||status==='502'" class="step-main-foot">
      <div class="step-main-foot-pay">
        去支付
      </div>
    </div>
    <div v-if="status==='394'" class="step-main-foot">
      <div class="step-main-foot-pay" style="background: #063F95;">
        去支付
      </div>
    </div>
  </div>
</template>

<script>
import {translateServiceClient} from "@/tools/api/service";
import {detailRequest, proDocumentRequest} from "@/tools/api/translate-api"

export default {
  name: "TransProStep",
  data() {
    return {
      title: '',
      status: '',
      timeCost: '',
      orderDate: '',
      processDate: '',
      payDate: '',
      transDate: '',
      overDate: '',
    }
  },
  beforeMount() {
    this.getDocument()
  },
  methods: {
    toQQ() {
      document.location.href = 'http://wpa.qq.com/msgrd?v=3&uin=1077258421&site=qq&menu=yes'
    },
    getDocument() {
      let documentId = this.$route.params.documentId;
      if (!documentId) {
        this.$router.push('/list')
      }
      let request = detailRequest
      request.setDocId(documentId)
      const TOKEN_KEY = 'token';
      translateServiceClient.getDetail(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        let title = res.getTitle();
        if (!title) {
          this.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: "当前文档暂时不支持查看详情"
          });
          this.$router.push('/list')
          return
        }
        this.title = title
        this.status = res.getStatus();
        this.timeCost = res.getTimeCost();
        this.orderDate = res.getOrderDate();
        this.processDate = res.getProcessDate();
        this.payDate = res.getPayDate();
        this.transDate = res.getTransDate();
        this.overDate = res.getOverDate();
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "当前文档暂时不支持查看详情"
        });
        this.$router.push('/list')
      })
    },
  }
}
</script>

<style lang="less" scoped>
.step-main {
  min-width: 765px;
  width: 100%;
  background: #f5f5f5;
  display: flex;
  flex-flow: column;
  align-items: center;

  .step-main-head {
    width: 100%;
    height: 248px;
    background: linear-gradient(180deg, #1E3C72, #2A5298);
    display: flex;
    align-items: center;
    justify-content: center;

    .step-main-head-content {
      width: 705px;
      height: 248px;
      display: flex;

      div:nth-child(1) {
        width: 19px;
        font-size: 48px;
        font-family: FangSong;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 72px;
      }

      div:nth-child(2) {
        margin-left: 15px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 72px;
      }
    }
  }

  .step-main-content {
    margin-top: -142px;
    width: 705px;
    height: 1300px;
    background: #FFFFFF;
    display: flex;
    flex-flow: column;

    .step-main-content-title {
      margin-top: 38px;
      margin-left: 29px;
      width: 536px;
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 56px;
    }

    .step-main-content-step {
      margin-top: 100px;
      display: flex;
      flex-flow: column;

      .step-main-content-foot {
        display: flex;
        flex-flow: column;
        margin-top: 100px;

        .step-main-content-foot-title {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          display: flex;
          align-items: center;

          div:nth-child(1) {
            width: 5px;
            height: 25px;
            background: #999999;
            margin-right: 10px;
          }
        }

        .step-main-content-foot-desc {
          margin-left: 17px;
          margin-top: 30px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
        }
      }

      .step-main-content-step-item {
        display: flex;
        margin-left: 33px;

        .step-main-content-step-item-one {
          margin-right: 33px;
          border-radius: 50%;
        }

        .step-main-content-step-item-two {
          height: 23px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #5F8ACA;
        }
      }

      .step-main-content-step-space {
        margin-left: 50px;
        width: 2px;
        height: 134px;
        background: #5F8ACA;
      }

      .step-main-content-step-item-status {
        display: flex;
        margin-left: 33px;

        .step-main-content-step-item-one {
          margin-right: 33px;
          border-radius: 50%;
        }

        .step-main-content-step-item-two {
          height: 23px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #F0833C;
        }
      }

      .step-main-content-step-space-status {
        margin-left: 50px;
        width: 2px;
        height: 134px;
        background: #F0833C;
      }

      .step-main-content-step-item-bank {
        display: flex;
        margin-left: 33px;

        .step-main-content-step-item-one {
          margin-right: 33px;
          border-radius: 50%;
        }

        .step-main-content-step-item-two {
          height: 23px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #DDDDDD;
        }
      }

      .step-main-content-step-space-bank {
        margin-left: 50px;
        width: 2px;
        height: 134px;
        background: #DDDDDD;
      }
    }

  }

  .step-main-foot {
    width: 100%;
    height: 120px;
    background: #FFFFFF;
    box-shadow: 0px -2px 24px 0px rgba(116, 114, 114, 0.5);
    display: flex;
    justify-content: flex-end;

    .step-main-foot-pay {
      width: 382px;
      height: 121px;
      background: #CCCCCC;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
      line-height: 110px;
    }
  }
}
</style>
